import React from 'react'
import PropTypes from 'prop-types'
import CustomCard from '../CustomCard'
import './style.sass'
import CustomButton from '../CustomButton'

const IconCard = ({ icon, iconVarient, mainText, mainButtonText, mainButtonOnClick }) => {
  return (
    <CustomCard>
      <div className="icon-card-component-container">
        {icon && (
          <div className="icon-container">
            <i className={`fa fa-${icon} icon-${iconVarient}`} />
          </div>
        )}
        <label>{mainText}</label>
        {!mainButtonOnClick || (
          <CustomButton
            onClick={mainButtonOnClick}
            buttonText={mainButtonText || "Click here"}
            className={`btn btn-outline`}
          />
        )}
      </div>
    </CustomCard>
  )
}

IconCard.propTypes = {
  icon: PropTypes.string.isRequired,
  iconVarient: PropTypes.oneOf(['primary', 'success', 'error', 'warn']),
  mainText: PropTypes.string.isRequired,
  mainButtonText: PropTypes.string,
  mainButtonOnClick: PropTypes.func,
}

export default IconCard
